// Finance build — React Query hook for the loan Financials tab's Income &
// Outflow read surface. Read-only; the query key comes from the co-located
// incomeLedgerKeys factory.

import { useQuery } from "@tanstack/react-query";
import { incomeLedgerApi } from "@/api/portfolioAdmin/incomeLedgerApi";
import { incomeLedgerKeys } from "./incomeLedgerKeys";

export function useLoanIncomeLedger(loanId: string | undefined) {
  return useQuery({
    queryKey: incomeLedgerKeys.loan(loanId ?? ""),
    queryFn: () => incomeLedgerApi.get(loanId!),
    enabled: !!loanId,
  });
}
